<template>
    <div v-if="themeStore.themeIndex === 3">
        <MssageContentView />
    </div>
    <StatusPopup ref="statusRef" />
</template>

<script setup lang="ts">
import StatusPopup from '@/components/common/statusPopup.vue';
import { useThemeStore } from '@/stores/theme';
import MssageContentView from '@/themes/themeThree/message/messageContentView.vue';

const themeStore = useThemeStore()
</script>
<style scoped>

</style>